export default "__VITE_ASSET__CmyFQdnp__"